import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import css from './index.styl?inline';
import template from './index.jade';

interface IconInputState {
  inputValue: string;
  disabled: boolean;
}

interface IconInputAttrs {
  disabled: boolean;
  icon: string;
  placeholder: string;
  value: string;
}

export default registerMPElement(
  `mp-icon-input`,
  class extends Component<IconInputState, {}, unknown, IconInputAttrs> {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        disabled: {
          type: `boolean`,
          default: false,
        },
        icon: `string`,
        placeholder: `string`,
        value: `string`,
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,
        defaultState: {
          disabled: false,
          inputValue: ``,
        },
        helpers: {
          clearInput: () => {
            this.update({inputValue: ``});
            this.focus();
            this.dispatchEvent(new Event(`input`));
          },
          handleInput: (ev) => {
            this.update({inputValue: ev.target.value});
          },
        },
      };
    }

    get value() {
      return this.state.inputValue;
    }

    set value(val) {
      this.update({inputValue: val});
    }

    private searchInput: HTMLInputElement;

    attributeChangedCallback(attr, oldValue, newValue) {
      super.attributeChangedCallback(attr, oldValue, newValue);
      switch (attr) {
        case `value`:
          this.update({inputValue: this.attr(attr)});
          break;
        case `disabled`:
          this.update({disabled: this.attr(attr)});
          break;
      }
    }

    focus() {
      if (this.searchInput) {
        this.searchInput.focus();
      } else {
        // try again after a frame if not ready
        requestAnimationFrame(() => this.focus());
      }
    }

    setElmRef(elm: HTMLInputElement) {
      this.searchInput = elm;
    }
  },
);
